/* tslint:disable */
/* eslint-disable */
/**
 * Farseer API
 * Farseer API
 *
 * The version of the OpenAPI document: 3
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export function SetMaintenanceRequestFromJSON(json) {
    return SetMaintenanceRequestFromJSONTyped(json, false);
}
export function SetMaintenanceRequestFromJSONTyped(json, ignoreDiscriminator) {
    if (json === undefined || json === null) {
        return json;
    }
    return {
        maintenance: json['maintenance'],
    };
}
export function SetMaintenanceRequestToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        maintenance: value.maintenance,
    };
}
